import { render } from "./label.vue?vue&type=template&id=7499ca2d&scoped=true"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"

import "./label.vue?vue&type=style&index=0&id=7499ca2d&scoped=true&lang=scss"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7499ca2d"]])

export default __exports__